import { ClassUtils } from "../../utils/ClassUtils";
import { genTileMesh } from "./MeshFactory";
export class TileMesh {
    constructor() {
        this.repeatX = true;
        this.repeatY = true;
    }
    onPopulateMesh(vb) {
        let tex = vb.mainTex;
        genTileMesh(vb, vb.contentRect, vb.uvRect, tex ? tex.sourceWidth : vb.contentRect.width, tex ? tex.sourceHeight : vb.contentRect.height, this.repeatX, this.repeatY);
    }
}
ClassUtils.regClass("TileMesh", TileMesh);
